module.exports = __webpack_public_path__ + "img/x10.8335e3f7.jpg";